import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=544af93d&lang=pug&"
import script from "./Wallet.vue?vue&type=script&lang=ts&"
export * from "./Wallet.vue?vue&type=script&lang=ts&"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=544af93d&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports